/* eslint no-console: 0 */
import MarkdownScript from 'helpers/markdownScript';
import { i18nData, i18nProvider, i18nExtend } from 'helpers/i18n'
import extensionActivitiesFile from './extensionActivities/extensionActivities.md';
import extensionActivitiesFile_fr_CA from './extensionActivities/extensionActivities.fr_CA.md';
import programPrepFile from './programPrep/programPrep.md';
import programPrepFile_fr_CA from './programPrep/programPrep.fr_CA.md';
import level1Prepfile from './sections/00_prep/level1_prep.md';
import level1Prepfile_fr_CA from './sections/00_prep/level1_prep.fr_CA.md';
import level2Prepfile from './sections/00_prep/level2_prep.md';
import level2Prepfile_fr_CA from './sections/00_prep/level2_prep.fr_CA.md';
import level3Prepfile from './sections/00_prep/level3_prep.md';
import level3Prepfile_fr_CA from './sections/00_prep/level3_prep.fr_CA.md';
import level4Prepfile from './sections/00_prep/level4_prep.md';
import level4Prepfile_fr_CA from './sections/00_prep/level4_prep.fr_CA.md';
import funFile from './fun.md';
import funFile_fr_CA from './fun.fr_CA.md';
import imageThumb_en from './images/h2whoa.png';
import imageThumb_fr_CA from './images/h2whoa.fr_CA.png';
import trialImageThumb_en from './images/h2whoaTrial.png';
import trialImageThumb_fr_CA from './images/h2whoaTrial.fr_CA.png';
import expiredImageThumb_en from './images/h2whoaExpired.png';
import expiredImageThumb_fr_CA from './images/h2whoaExpired.fr_CA.png';
import config from './config';

// Preload image functions
import { preloadGameShow } from './sections/20_gameShow/gameShowSection';

import './theme.scss';

import md from './md';

const level1PrepMd = i18nData({
  en: new MarkdownScript(level1Prepfile),
  fr_CA: new MarkdownScript(level1Prepfile_fr_CA)
});
const level2PrepMd = i18nData({
  en: new MarkdownScript(level2Prepfile),
  fr_CA: new MarkdownScript(level2Prepfile_fr_CA)
});
const level3PrepMd = i18nData({
  en: new MarkdownScript(level3Prepfile),
  fr_CA: new MarkdownScript(level3Prepfile_fr_CA)
});
const level4PrepMd = i18nData({
  en: new MarkdownScript(level4Prepfile),
  fr_CA: new MarkdownScript(level4Prepfile_fr_CA)
});
const extensionActivitiesMd = i18nData({
  en: new MarkdownScript(extensionActivitiesFile),
  fr_CA: new MarkdownScript(extensionActivitiesFile_fr_CA)
});
const programPrepMd = i18nData({
  en: new MarkdownScript(programPrepFile),
  fr_CA: new MarkdownScript(programPrepFile_fr_CA)
});
const funMd = i18nData({
  en: new MarkdownScript(funFile),
  fr_CA: new MarkdownScript(funFile_fr_CA)
});
const imageThumb = i18nData({
  en: imageThumb_en,
  fr_CA: imageThumb_fr_CA
});
const trialImageThumb = i18nData({
  en: trialImageThumb_en,
  fr_CA: trialImageThumb_fr_CA
});
const expiredImageThumb = i18nData({
  en: expiredImageThumb_en,
  fr_CA: expiredImageThumb_fr_CA
});

i18nExtend('fr_CA', {
  "H2Whoa": "H2Ohhh",
  "One Water": "Une seule eau",
  "Save Water": "Économiser l'eau",
  "Protect Water": "Protéger l'eau",
  "Connect in Place": "Se connecter à son milieu"
})

const levels = {
  prep: {
    deck: require('./levelPrep')
  },
  1: {
    thumbnail: require('./images/level-1_start.png'),
    overviewThumbnail: require('./images/overview/level-1_start.png'),
    deck: require('./level1'),
    prep: level1PrepMd,
    levelName: 'One Water'
  },
  2: {
    thumbnail: require('./images/level-2_start.png'),
    overviewThumbnail: require('./images/overview/level-2_start.png'),
    deck: require('./level2'),
    prep: level2PrepMd,
    levelName: 'Save Water'
  },
  3: {
    thumbnail: require('./images/level-3_start.png'),
    overviewThumbnail: require('./images/overview/level-3_start.png'),
    deck: require('./level3'),
    prep: level3PrepMd,
    levelName: 'Protect Water'
  },
  4: {
    thumbnail: require('./images/level-4_start.png'),
    overviewThumbnail: require('./images/overview/level-4_start.png'),
    deck: require('./level4'),
    prep: level4PrepMd,
    levelName: 'Connect in Place'
  },
  completed: {
    deck: require('./levelCompleted')
  }
};

const program = {
  id: 'h2whoa',
  title: i18nProvider(lang => md[lang].getSectionAsString('Title - Short')),
  longTitle: i18nProvider(lang => md[lang].getSectionAsString('Title - Long')),
  thumbnailImage: imageThumb,
  trialImageThumb,
  expiredImageThumb,
  longDescription: i18nProvider(lang => md[lang].getSectionAsString('Description - Long')),
  levelsDescription: i18nProvider(lang => md[lang].getSectionAsString('Description - Levels')),
  shortDescription: i18nProvider(lang => md[lang].getSectionAsString('Description - Short')),
  levels,
  extensionActivitiesMd,
  programPrepMd,
  funMd,
  preload: ({ level }) => {
    console.log(`Preloading assets for Level ${level}`);

    preloadGameShow();
  },
  config,
  languages: ['en', 'fr_CA']
};

export default program;



// WEBPACK FOOTER //
// ./programs/h2whoa/index.js